import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimTypeDealerAutomationRule.Delete.IRequest;
type Response = Api.Core.ClaimTypeDealerAutomationRule.Delete.IResponse;
type Headers = Api.Core.ClaimTypeDealerAutomationRule.Delete.IHeaders;
const deleteApiClaimTypeDealerAutomationRulePath = '/api/DealerManagement/ClaimTypeDealerAutomationRule/:id';
export default async function claimTypeDealerAutomationRuleDeleteApi(params: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    url: createPathFromRoute(deleteApiClaimTypeDealerAutomationRulePath, params),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
